import React from 'react';

// Components
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Typography,
} from '@mui/material';
import {
  AccountBoxRounded,
  CachedRounded,
  CompareArrowsRounded,
  DoubleArrowRounded,
  ExpandMoreRounded,
  LinkRounded,
} from '@mui/icons-material';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';
import * as styles from './SubscriptionLegend.styles';

const legendItems = [
  {
    icon: <ContentPasteRoundedIcon />,
    title: 'Product Transfer Orders',
  },
  {
    icon: <AssignmentTurnedInRoundedIcon />,
    title: 'Reconsignment Control',
  },
  {
    icon: <DoubleArrowRounded />,
    title: 'Shipment Distributions',
  },
  {
    icon: <CompareArrowsRounded />,
    title: 'PTO Chaining',
  },
  {
    icon: <AccountBoxRounded />,
    title: 'Supplier Authorizations',
  },
  {
    icon: <CachedRounded />,
    title: 'Two-Party Exchanges',
  },
  {
    icon: <LinkRounded />,
    title: 'Shipment Chaining',
  },
];

const SubscriptionLegend = () => {
  return (
    <Box margin="0 auto" maxWidth="1224px" pb={3} px={3} width="100%">
      <Accordion defaultExpanded elevation={0} sx={styles.accordionRoot}>
        <AccordionSummary
          expandIcon={<ExpandMoreRounded />}
          sx={[
            styles.accordionTitle,
            { '.MuiAccordionSummary-expandIconWrapper': styles.expandIcon },
          ]}
        >
          <Typography variant="body1">Volume-Based Features</Typography>
        </AccordionSummary>
        <AccordionDetails sx={styles.accordionPanelDetailsContainer}>
          <Box sx={styles.legendItemsContainer}>
            {legendItems.map(({ title, icon }) => (
              <Box alignItems="center" display="flex" key={title}>
                <Avatar sx={styles.avatar}>{icon}</Avatar>
                <Typography sx={{ color: 'primary.main', pl: 1 }} variant="body2">
                  {title}
                </Typography>
              </Box>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SubscriptionLegend;
